import React from 'react';
import { AppBar, Toolbar, Typography, Button, Box } from '@mui/material';
import { Link } from 'react-scroll';

const Header = () => {
  return (
    <AppBar position="fixed">
      <Toolbar>
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          Cesar Moy
        </Typography>
        <Box>
          <Button color="inherit" component={Link} to="about" smooth={true}>
            About
          </Button>
          <Button color="inherit" component={Link} to="experience" smooth={true}>
            Experience
          </Button>
          <Button color="inherit" component={Link} to="skills" smooth={true}>
            Skills
          </Button>
          {/* <Button color="inherit" component={Link} to="projects" smooth={true}>
            Projects
          </Button> */}
          <Button color="inherit" component={Link} to="contact" smooth={true}>
            Contact
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;